import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/NutricionistaBrasileiraSydney";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";
import { SITE_URL } from "@/lib/seo";
const cityService = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Clara Camille - Nutricionista para brasileiros em Sydney",
  description: "Nutricionista brasileira com atendimento online em português para quem mora em Sydney.",
  url: `${SITE_URL}/nutricionista-brasileira-sydney`,
  parentOrganization: { "@id": `${SITE_URL}/#business` },
  areaServed: { "@type": "City", name: "Sydney", containedInPlace: { "@type": "State", name: "New South Wales" } },
  availableLanguage: ["Portuguese"],
  telephone: "+61423038977",
  priceRange: "$$",
};

export const Route = createFileRoute("/nutricionista-brasileira-sydney")({
  head: () =>
    pageHead({
      title: "Nutricionista brasileira em Sydney | Clara Camille",
      description:
        "Nutricionista brasileira em Sydney. Atendimento online em português com plano alimentar adaptado à sua rotina. Consulta inicial gratuita.",
      path: "/nutricionista-brasileira-sydney",
      ogDescription: "Atendimento online em português para brasileiros em Sydney. Consulta inicial gratuita.",
      jsonLd: [
        breadcrumbJsonLd([{ name: "Nutricionista brasileira em Sydney", path: "/nutricionista-brasileira-sydney" }]),
        cityService,
        faqJsonLd(faqItems),
      ],
    }),
  component: Page,
});
